






import type { Filter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CdlRatingCheckboxFilterTitle extends Vue {
  @Prop({ required: true })
  filter: Filter;

  get rating() {
    return Number.parseInt(this.filter.title, 10);
  }
}
